// test1220
(1220 && 0);
